<template>
  <div class="filter-item">
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <md-field>
          <label for="shift">Эквайринг</label>
            <md-select v-model="value" name="acquiring" id="acquiring" @md-selected="changeFilter" md-dense>
            <md-option v-for="v in items"
                       :value="v.value"
                       :key="v.value">{{ v.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'acquiring',
  data () {
    return {
      items: [{name: 'Все', value: 'deleteFilter'},
        {name: 'Включен', value: 1},
        {name: 'Выключен', value: 0}],
      value: null
    }
  },
  methods: {
    changeFilter () {
      this.$store.commit('setFilter', {name: 'is_acquiring_enabled', value: this.value})
      this.$emit('changeFilter')
    }
  },
  created () {
    if (this.$store.state.filtersShop['is_acquiring_enabled'] !== null) {
      this.value = this.$store.state.filtersShop.acquiring
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/filters/shop/acquiring.vue